import { LineWave } from 'react-loader-spinner';

export const GraphLoader = () => (
  <div className="main-login-loader main-login-loader-reltaive">
  <div className="login-loader">
    <LineWave width="100" strokeColor="#111" />
  </div>
  </div>
);